module.exports = __webpack_public_path__ + "img/pacific_crest_ba_list.01b5e96f.jpg";